import { createColumnHelper } from "@tanstack/react-table";
import Button from "../../../components/Button";
import { ButtonTypeEnum } from "../../../enums/ButtonTypeEnum";
import { capitalizeEachWord } from "../../../helpers/StringHelper";

export type Item = {
    id: number;
    scan_date: string;
    onDelete: (id_presensi: number) => void;
};

const columnHelper = createColumnHelper<Item>();
export const columns = [
    columnHelper.accessor((row) => row.scan_date, {
        id: "alasan",
        cell: (info) => <>{info.getValue()}</>,
        header: () => <span>Scan Date</span>,
        footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row, {
        id: "action",
        cell: (info) => <>
            <div className="flex flex-col gap-2 w-40">
                <Button
                    onClick={() => info.row.original.onDelete(info.row.original.id)}
                    text="Delete"
                    size="lite"
                    color="danger"
                    buttonType={ButtonTypeEnum.CLICKABLE_TEXT}
                />
            </div>
        </>,
        header: () => <span>Action</span>,
        footer: (info) => info.column.id,
    }),
];
